import { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle';

import loadable from '../../../utils/loadable';

import WatchlistControls from '../WatchlistControls';
import WatchlistTopicsList from '../WatchlistTopicsList';
import { clearSavedTrendingFiltersStates } from '../../../services/localStorage';
import WatchlistDropDown from '../WatchlistDropDown';
import PiwikContext from '../../../services/piwikContext';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const TrendingPersonalisationFilter = loadable(() => import('../../MainTrending/TrendingFilters/TrendingPersonalisationFilter'));
const cx = classNames.bind(Styles);

export class WatchlistFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personalisationExpand: false,
      openTopics: false,
    };
    autoBind(this);
  }

  toggleExpand(type, value) {
    this.setState({
      [type]: value,
    });
  }

  resetTrendingFilters() {
    const { actions } = this.props;

    clearSavedTrendingFiltersStates();
    actions.resetTrendingFilters();
  }

  renderFilters() {
    const {
      dropDownOpen,
      user,
      client,
      width,
    } = this.props;
    const { personalisationExpand, openTopics } = this.state;

    if (personalisationExpand) {
      return (
        <PiwikContext.Consumer>
          {(value) => (
            <TrendingPersonalisationFilter
              user={user}
              piwikEnabled={value.piwikEnabled}
            />
          )}
        </PiwikContext.Consumer>
      );
    }
    if (dropDownOpen) {
      return (
        <PiwikContext.Consumer>
          {(value) => (
            <WatchlistDropDown
              client={client}
              piwikEnabled={value.piwikEnabled}
            />
          )}
        </PiwikContext.Consumer>
      );
    }
    if (openTopics && width <= 1024) {
      return (
        <PiwikContext.Consumer>
          {(value) => (
            <WatchlistTopicsList
              client={client}
              piwikEnabled={value.piwikEnabled}
            />
          )}
        </PiwikContext.Consumer>
      );
    }
    return null;
  }

  render() {
    const {
      width,
      isWatchlistPage = true,
      activateFilingsPreloader,
      activeWatchlistTopics,
    } = this.props;
    const { personalisationExpand, openTopics } = this.state;

    const isExpanded = personalisationExpand || openTopics;
    const filtersDropDownClass = cx({
      watchlist_filters_dropdown: true,
      expanded: isExpanded,
    });
    const isOneTopicSelected = activeWatchlistTopics.some(({ hidden }) => !hidden);

    return (
      <div className={Styles.watchlist_stories_header}>
        <PiwikContext.Consumer>
          {(value) => (
            <WatchlistControls
              personalisationExpand={personalisationExpand}
              openTopics={openTopics}
              onExpandChange={this.toggleExpand}
              width={width}
              piwikEnabled={value.piwikEnabled}
              isWatchlistPage={isWatchlistPage}
              hasBigScreenDesign
            />
          )}
        </PiwikContext.Consumer>
        {!activateFilingsPreloader && (!activeWatchlistTopics.length || !isOneTopicSelected)
        && !isExpanded && (
          <div className={Styles.assets_no_topics}>
            <FontAwesomeIcon icon={faExclamationCircle} />
            <div className={Styles.no_topic_text}>
              Please add or select at least one topic in the watchlist to get relevant news and analytics
            </div>
          </div>
        )}
        <div className={filtersDropDownClass}>
          {this.renderFilters()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ common, watchlistReducer }) => ({
  dropDownOpen: watchlistReducer.newWatchlistDropDown,
  activateFilingsPreloader: watchlistReducer.activateFilingsPreloader,
  activeWatchlistTopics: watchlistReducer.activeWatchlistTopics,
  width: common.width,
});

export default withComponentName(
  connect(mapStateToProps, null)(WatchlistFilters),
);
